import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './config/en'
import zh from './config/zh'
import ru from './config/ru'
import {BaseUtil} from '@zkwq/business'
const messages = {
  en,
  zh,
  ru
}

Vue.use(VueI18n)

let locale = BaseUtil.getStorage('app_locale')

export default new VueI18n({
  locale: locale ? locale : 'zh',
  messages
})


